var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":function($event){return _vm.handleClick()}}},[[_c('span',{staticStyle:{"display":"inline-block","color":"red"}},[_vm._v(_vm._s(_vm.row.name))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }